import { render, staticRenderFns } from "./RegistrationSelfieComponent.vue?vue&type=template&id=60d9aa3a&lang=pug&"
import script from "./RegistrationSelfieComponent.vue?vue&type=script&lang=ts&"
export * from "./RegistrationSelfieComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports